var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_32708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.704 15.7692H17.6992L20.2041 0.280746H24.2087L21.704 15.7692Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2204 0.659389C35.4305 0.346002 34.1776 -1.52588e-05 32.6284 -1.52588e-05C28.6735 -1.52588e-05 25.8885 2.10894 25.8714 5.1241C25.8386 7.34869 27.8654 8.58428 29.3813 9.32602C30.9307 10.084 31.4574 10.5787 31.4574 11.2543C31.4416 12.2919 30.2054 12.7702 29.0524 12.7702C27.4535 12.7702 26.5967 12.5236 25.2948 11.9463L24.7674 11.6989L24.207 15.1757C25.1463 15.6036 26.8768 15.9833 28.6735 16C32.8756 16 35.6114 13.9237 35.6438 10.7105C35.6598 8.94738 34.5895 7.59638 32.2822 6.49241C30.8814 5.78373 30.0236 5.30587 30.0236 4.58077C30.0401 3.92159 30.7492 3.24641 32.3303 3.24641C33.6323 3.21335 34.5889 3.52629 35.3135 3.83946L35.6758 4.00393L36.2204 0.659389Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5438 10.2822C41.8736 9.39238 43.1427 5.94864 43.1427 5.94864C43.126 5.9817 43.4718 5.04242 43.6696 4.4658L43.9494 5.80037C43.9494 5.80037 44.7078 9.50779 44.8725 10.2822C44.2466 10.2822 42.3348 10.2822 41.5438 10.2822ZM46.4872 0.280746H43.3895C42.4342 0.280746 41.7084 0.560626 41.2963 1.56583L35.3477 15.7689H39.5498C39.5498 15.7689 40.2416 13.8573 40.3903 13.4456C40.8513 13.4456 44.9391 13.4456 45.5321 13.4456C45.6471 13.9894 46.01 15.7689 46.01 15.7689H49.7181L46.4872 0.280746Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3563 0.280746L10.4343 10.8424L10.0057 8.70036C9.28058 6.22874 7.0065 3.54338 4.46875 2.20815L8.0612 15.7528H12.2962L18.5911 0.280746H14.3563Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79053 0.280746H0.347168L0.28125 0.593695C5.30748 1.879 8.63625 4.97716 10.0039 8.70101L8.60318 1.58269C8.37257 0.593476 7.6639 0.313377 6.79053 0.280746Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_32708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.4379,
    height: 16,
    fill: "white",
    transform: "translate(0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa_logo.e8d2432e352052be4462e06c6652bb0b.svg";
export { ForwardRef as ReactComponent };